import React, { FC, useMemo } from 'react';

import { AlarmSeverity } from '@x-guard/xgac-types/xgac';
import { useLocale } from 'lib';
import { TranslationKey } from 'config/i18n';
import { useSelector } from 'react-redux';
import { alarmDetailsSelector } from 'features/details';
import { BetterMarkdown } from 'components/molecules';
import { ProcedurePriorityButtons } from './useProcedurePriority';
import { ProcedureGuide } from './guide';
import styles from './style.module.scss';

const alarmSeverityToDefaultTranslation: Record<AlarmSeverity, TranslationKey> = {
  [AlarmSeverity.Red]: 'Alarm_Detail_Response_Protocol_Panic',
  [AlarmSeverity.Orange]: 'Alarm_Detail_Response_Protocol_Assistance',
  [AlarmSeverity.Green]: 'Alarm_Detail_Response_Protocol_Test',
};

export const Procedure: FC = () => {

  const { procedure, severity } = useSelector(alarmDetailsSelector);
  const { t } = useLocale();

  const steps = useMemo<string>(() => {

    if (procedure) return procedure;

    return t(alarmSeverityToDefaultTranslation[severity] ?? 'Alarm_Detail_Response_Protocol_Test');

  }, [procedure, severity, t]);

  return (
    <>
      <section className={styles.box}>
        <div className={styles.protocolHeader}>
          <span>{t('Protocol_Response')}</span>
          <ProcedureGuide/>
        </div>
        <div className={styles.protocolBody}>
          <div className={styles.steps}>
            <BetterMarkdown>
              {steps}
            </BetterMarkdown>
          </div>
        </div>
      </section>
      <section className={styles.box}>
        <div className={styles.protocolHeader}>
          <span>{t('Alarm_Detail_Response_Procedure.Priority.Title')}</span>
        </div>
        <div className={styles.protocolBody}>
          <ProcedurePriorityButtons/>
        </div>
      </section>
    </>
  );

};
